import * as React from "react";
const SvgFiRrVectorPolygon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-vector-polygon_svg__a)">
      <path
        fill="#062147"
        d="M20 6h2c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2H6c0-1.103-.897-2-2-2H2C.897 0 0 .897 0 2v2c0 1.103.897 2 2 2v12c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h12c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2h-2q-.253 0-.488.06l-3.67-4.281c.102-.24.158-.503.158-.779v-2c0-.276-.056-.539-.158-.779l3.67-4.281Q19.747 6 20 6m0-4h2v2h-2zm0 18h2v2h-2zM2 2h2v2H2zm0 20v-2h2v2zm4-2c0-1.103-.897-2-2-2V6c1.103 0 2-.897 2-2h12q.002.283.075.542l-3.834 4.473A2 2 0 0 0 14 9h-2c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h2q.123 0 .241-.015l3.834 4.473A2 2 0 0 0 18 20zm6-7v-2h2v2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-vector-polygon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVectorPolygon;
